<template>
  <v-app id="inspire" class="transparent" v-resize="onResize">
    <v-navigation-drawer style="border: 0px" v-if="$store.state.loggedIn" app v-model="drawer">
      <v-list dense nav flat class="py-0">
        <v-list-item-group v-model="menuActive" mandatory color="secondary">
          <v-list-item class="mb-0" two-line to="/Profile">
            <v-list-item-avatar>
              <v-icon color="primary" large>account_circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>{{user}}</v-list-item-title>
          </v-list-item>
          <!-- <v-divider></v-divider> -->
          <template v-for="(item,i) in items">
            <template v-if="item.can">
              <template v-if="item.sub">
                <v-list-group color="primary" :key="i">
                  <template v-slot:activator>
                    <!-- <v-list-item-icon>
                      <v-icon color="primary">{{item.icon}}</v-icon>
                    </v-list-item-icon>-->
                    <v-list-item-icon>
                      <v-badge
                        overlap
                        :value="item.notification"
                        :content="item.notification"
                        :color="item.color"
                      >
                        <v-icon color="primary">{{item.icon}}</v-icon>
                      </v-badge>
                      <!-- <v-icon v-else color="primary">{{item.icon}}</v-icon> -->
                    </v-list-item-icon>
                    <v-list-item-title>{{item.text}}</v-list-item-title>
                  </template>
                  <v-list-item-group v-model="menuActive" mandatory color="secondary">
                    <template v-for="(subgroup,i) in item.subgroups">
                      <v-list-item
                        v-if="subgroup.can"
                        class="ml-6 mb-0"
                        :key="i"
                        :to="{path: subgroup.name}"
                      >
                        <v-list-item-icon>
                          <v-badge
                            overlap
                            :value="subgroup.notification"
                            :content="subgroup.notification"
                            :color="subgroup.color"
                          >
                            <v-icon color="primary">{{subgroup.icon}}</v-icon>
                          </v-badge>
                          <!-- <v-icon v-else color="primary">{{item.icon}}</v-icon> -->
                        </v-list-item-icon>
                        <!-- <v-list-item-icon>
                          <v-icon color="primary">{{subgroup.icon}}</v-icon>
                        </v-list-item-icon>-->
                        <v-list-item-content>
                          <v-list-item-title>{{subgroup.text}}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list-group>
              </template>
              <v-list-item v-else class="mb-0" :key="i" :to="{path: item.name}">
                <v-list-item-icon>
                  <v-badge
                    overlap
                    :value="item.notification"
                    :content="item.notification"
                    :color="item.color"
                  >
                    <v-icon color="primary">{{item.icon}}</v-icon>
                  </v-badge>
                  <!-- <v-icon v-else color="primary">{{item.icon}}</v-icon> -->
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{item.text}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!-- <v-divider :key="i+'d'"></v-divider> -->
            </template>
          </template>
        </v-list-item-group>
      </v-list>
      <div class="pa-2">
        <can I="download" a="excel">
          <v-btn block depressed class="mb-2" color="success" @click="downloadExcel">
            <v-icon small>save_alt</v-icon>Download Excel
          </v-btn>
        </can>
        <can I="download" a="stickers">
          <downloadStickers></downloadStickers>
        </can>
      </div>
      <template v-slot:append>
        <div class="pa-2" style="margin-bottom: 110px">
          <v-btn @click="logout" color="primary" block>
            <v-icon color="white" small large>exit_to_app</v-icon>
            {{$t('signout')}}
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      class="pa-0"
      dense
      v-if="$store.state.loggedIn"
      dark
      :color="$store.state.colors.primary"
      flat
      app
    >
      <!-- <v-btn v-if="$route.name === 'Projects' " icon><v-icon>$menu</v-icon></v-btn>
      <v-btn v-else icon color="white"><v-icon>fa-arrow-left</v-icon></v-btn>-->
      <router-view v-on:openDrawer="toggleDrawer" name="header"></router-view>
      <!-- <v-app-bar-nav-icon icon="fa-edit" @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
      <template v-if="!$store.state.isOffline">
        <v-toolbar-title>
          <router-link :to="{ name: 'Projects' }">
            <a style="color: white">
              <img src="@/assets/logo.svg" width="40" height="40" />
              <template v-if="$vuetify.breakpoint.smAndUp">FIRELOG</template>
            </a>
          </router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu
          v-if="releaseNoteOverview"
          transition="scale-transition"
          origin="right top"
          v-model="menu"
          left
          :close-on-content-click="false"
          :nudge-width="200"
          max-height="500"
          max-width="500"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn text @click="readReleaseNotes" v-bind="attrs" v-on="on">
              <v-badge
                left
                color="error"
                :value="releaseNoteOverview.count"
                :content="releaseNoteOverview.count"
                overlap
              >
                <v-icon color="white" small>fa-bell</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <v-card class="pa-2">
            <v-card-title>
              <v-icon color="secondary" large left>fa-newspaper</v-icon>
              <span class="title">{{$t('whatsnew')}}</span>
            </v-card-title>
            <v-sheet class="overflow-auto" max-height="400">
              <div v-for="(note,i) in releaseNoteOverview.releaseNotes" :key="i">
                <div class="mb-1" outlined>
                  <div class="container">
                    <div class="title font-weight-light">{{note.title}}</div>
                    <small>{{note.date}}</small>
                    <div v-html="getDescription(note.description)"></div>
                  </div>
                  <!-- <v-list>
              <v-list-item>
                <div v-html="note.description"></div>
              </v-list-item>
                  </v-list>-->
                </div>
                <v-divider></v-divider>
              </div>
            </v-sheet>
          </v-card>
        </v-menu>
        <div class="text-xs-center">
          <v-menu transition="scale-transition" origin="right top" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <template>{{$i18n.locale}}</template>
                <v-spacer></v-spacer>
                <v-icon>language</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(language, index) in $store.state.languages"
                :key="index"
                @click="changeLanguage(language.code)"
              >
                <v-list-item-icon>{{ fromCodePoint(language.flag) }} {{language.name}}</v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <!-- <v-btn icon>
              <v-icon @click="logout">exit_to_app</v-icon>
        </v-btn>-->
      </template>
      <div v-else class="amber--text mx-auto darken-2 text-center">
        <span class="white--text">{{loadingText}}</span>
      </div>
      <!-- <div v-else class="mx-auto text-center">
            Offline
            <v-icon>signal_wifi_off</v-icon>
      </div>-->
    </v-app-bar>

    <v-content>
      <div :class="$vuetify.breakpoint.lgAndUp? 'pa-5':''">
        <router-view name="breadcrumb"></router-view>
        <router-view :key="$route.fullPath" name="default"></router-view>
      </div>
    </v-content>
    <loadingDialog :dialog="loading"></loadingDialog>
    <v-dialog v-model="$store.state.offlineSyncing"  persistent width="300">
      <v-card flat color="primary" dark>
        <v-card-text>
          {{loadingText}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <superUser v-if="isSuper" :dialog="true"></superUser>
  </v-app>
</template>

<script>
import "vuejs-noty/dist/vuejs-noty.css";
import "vuetify/dist/vuetify.min.css";
import downloadStickers from "@/components/DownloadStickers";
import superUser from "@/components/SuperUser";
import settings from "./settings/settings.js";
import jwtdecode from "jwt-decode";

export default {
  name: "app",
  components: {
    downloadStickers,
    superUser
  },
  data() {
    return {
      drawer: true,
      user: "",
      noConnection: false,
      loading: false,
      loadingText: "",
      menuActive: 0,
      notifications: {},
      releaseNoteOverview: null,
      menu: false,
    };
  },
  methods: {
    getDescription(descriptions) {
      return descriptions[localStorage.getItem("language").toLowerCase()] !==
        undefined
        ? descriptions[localStorage.getItem("language").toLowerCase()]
        : "";
    },
    readReleaseNotes() {
      this.$http
        .readReleaseNotes()
        .then((res) => {
          this.releaseNoteOverview.count = 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getReleaseNotes() {
      this.$http
        .getReleaseNotes()
        .then((res) => {
          this.releaseNoteOverview = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkIfUserHasAcceptedTermsAndServices() {
      // if (
      //   jwtdecode(localStorage.getItem("auth")).license.QRLOG
      //     .acceptTermsAndService
      // ) {
      //   this.$router.push({
      //     name: "Terms"
      //   });
      // }
    },
    changeLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
      this.$router.go();
    },
    logout() {
      this.$router.push({
        name: "Login",
      });

      this.$store.state.loggedIn = false;
    },
    login() {
      this.$store.state.loggedIn = true;
      this.user = localStorage.getItem("user");
    },
    goBack() {
      if (this.$store.state.previous) {
        this.$router.push({
          name: this.$store.state.previous.name,
          params: { id: this.$store.state.previous.id },
        });
      } else {
        this.$router.push({
          name: "Projects",
        });
      }
    },
    downloadExcel() {
      this.loading = true;
      this.$http
        .downloadExcelExport()
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          let date = new Date();
          link.setAttribute(
            "download",
            `Excel_Overview${date.toLocaleDateString()}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch((err) => {
          this.$noty.error(this.$t("error"));
          console.log(err);
          this.loading = false;
        });
    },

    fromCodePoint(codepoint) {
      if (codepoint.split(" ").length > 0) {
        return (
          String.fromCodePoint(codepoint.split(" ")[0]) +
          String.fromCodePoint(codepoint.split(" ")[1])
        );
      }
      return String.fromCodePoint(codepoint);
    },
    onResize() {
      if (window.innerWidth <= 1264) {
        this.$store.state.isMobile = true;
      } else {
        this.$store.state.isMobile = false;
      }
    },
    checkConnection() {
      if (!navigator.onLine) this.noConnection = true;
      window.addEventListener("offline", () => {
        this.noConnection = true;
        this.$store.state.isOffline = true;
      });
      window.addEventListener("online", () => {
        this.noConnection = false;
        this.$store.state.isOffline = false;
      });
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    async getNotifications() {
      try {
        let res = await this.$http.getNotifications();
        this.notifications = res.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  beforeCreate: function () {
    document.body.className = "home";
  },
  watch: {
    async isOffline(n, o) {
      // this.dialog = true;
      this.loadingText = this.$t("notOnline");
      let vm = this;
      if (n) {
        this.drawer = false;
        window.onbeforeunload = function () {
          return "You're leaving the site.";
        };
      } else {
        window.onbeforeunload = function () {
          return "You're leaving the site.";
        };
        if (this.$store.state.offForm.length > 0) {
          window.onbeforeunload = function () {
            return undefined;
          };

          this.$store.state.offlineSyncing = true;
          try {
            let deleteMxSRequests = [];
            let newMarkerRequests = [];
            let updateMarkerRequests = [];

            let linkQRRequests = [];
            this.$store.state.offForm.forEach((element) => {
              if (element.marker.new) {
                newMarkerRequests.push(this.$http.addMarker(element.marker));
              } else {
                updateMarkerRequests.push(
                  this.$http.updateMarker(element.marker)
                );
              }
              if (element.deleteMarkerXSolution) {
                deleteMxSRequests.push(
                  this.$http.deleteMarkerXSolution(
                    element.deleteMarkerXSolution
                  )
                );
              }
            });

            this.loadingText = this.$t("await: new/update markers");
            let newMarkers = await Promise.all(newMarkerRequests);
            newMarkers.forEach((res) => {
              this.$store.commit("AddAndSetUIelements", res.data);
              if (this.$store.state.markersReadonly.length > 0) {
                this.$store.commit("AddAndSetUIelementsReadonly", res.data);
              }
              this.$forceUpdate();
            });
            let updatedMarkers = await Promise.all(updateMarkerRequests);
            updatedMarkers.forEach((res) => {
              this.$store.commit("AddAndSetUIelements", res.data);
              
              if (this.$store.state.markersReadonly.length > 0) {
                this.$store.commit("AddAndSetUIelementsReadonly", res.data);
              }
              this.$forceUpdate();
            });
            this.loadingText = this.$t("done: new/update markers");
            this.loadingText = this.$t("await: delete mxs");
            await Promise.all(deleteMxSRequests);
            this.loadingText = this.$t("done: delete mxs");
            // if (this.$store.state.offQrs.length > 0) {
            //   this.$store.state.offQrs.forEach((o) => {
            //     linkQRRequests.push(
            //       this.$http.getMarkerByQRId(o.qrId, o.markerId)
            //     );
            //   });
            // }
            // this.loadingText = this.$t("await linkQRRequests");
            // await Promise.all(linkQRRequests)
            // .then(async res => {
            //   let updatedMarkersAgain = await Promise.all(updateMarkerRequestsAgain);
            // updatedMarkersAgain.forEach((res) => {
            //   this.$store.commit("AddAndSetUIelements", res.data);
            //   if (this.$store.state.markersReadonly.length > 0) {
            //     this.$store.commit("AddAndSetUIelementsReadonly", res.data);
            //   }
            //   this.$forceUpdate();
            // });
            // })
            // .catch(err => {
            //   console.log(err)
            // })
            // console.log("qrcodes")
            // this.loadingText = this.$t("done: link QR codes");
            // this.loadingText = this.$t("done syncing offline changes");
            // this.$router.go();

            this.$store.state.offlineSyncing = false;
            //reset offline form
            this.$store.state.offForm = [];
            
          } catch (error) {
            this.loadingText = error;
            console.log(error);
            this.$noty.error(error);
            this.$store.state.offlineSyncing = false;
            //reset offline form
            this.$store.state.offForm = [];
          }
        } else {
          this.dialog = false;
          window.onbeforeunload = function () {
            return undefined;
          };
        }
      }
    },
    $route(to, from) {
      if (localStorage.getItem("auth") != null) {
        this.checkIfUserHasAcceptedTermsAndServices();
      }
    },
  },
  computed: {
    isSuper(){
      var tokenRaw = localStorage.getItem("auth")
      let token = tokenRaw != null ? jwtdecode(tokenRaw) : null

      return token != null && token.QRLOG && token.QRLOG.includes('shadow_account')
    },
    items() {
      return [
        {
          sub: true,
          text: this.$t("projects"),
          icon: "home",
          notification: 0,
          subgroups: [
            {
              name: "/",
              text: this.$t("activeProjects"),
              icon: "device_hub",
              can: this.$can("read", "projects"),
              notification: 0,
            },
            {
              name: "/Archived/Projects",
              text: this.$t("archivedProjects"),
              icon: "archive",
              can: this.$can("read", "archivedProjects"),
              notification: 0,
            },
          ],
          can: this.$can("read", "projects"),
        },
        {
          sub: this.$can("read", "usersTodos") ? true : false,
          name: "/Todo",
          text: this.$can("read", "usersTodos")
            ? this.$t("todos")
            : this.$t("myTodos"),
          can: this.$can("read", "todos"),
          icon: "assignment",
          color: "secondary",
          notification: this.$can("read", "usersTodos")
            ? 0
            : this.notifications.todos
            ? this.notifications.todos
            : 0,
          subgroups: [
            {
              name: "/Todo",
              color: "secondary",
              text: this.$t("myTodos"),
              icon: "assignment",
              can: this.$can("read", "todos"),
              notification: this.notifications.todos
                ? this.notifications.todos
                : 0,
            },
            {
              name: "/Todos/installers",
              color: "secondary",
              text: this.$t("todosForInstallers"),
              icon: "playlist_add_check",
              notification: 0,
              can: this.$can("read", "usersTodos"),
            },
          ],
        },
        {
          sub: true,
          text: this.$t("reports"),
          icon: "report_problem",
          color: "red",
          notification: this.notifications.reports
            ? this.notifications.reports
            : 0,
          subgroups: [
            {
              name: "/Reports",
              text: this.$t("reports"),
              icon: "report_problem",
              can: this.$can("read", "reports"),
              color: "red",
              notification: this.notifications.reports
                ? this.notifications.reports
                : 0,
            },
            {
              name: "/Reports/old",
              text: this.$t("archivedReports"),
              icon: "fa-history",
              can: this.$can("read", "reports"),
              notification: 0,
            },
          ],
          can: this.$can("read", "reports"),
        },

        {
          sub: true,
          text: this.$t("settings"),
          icon: "settings",
          notification: 0,
          subgroups: [
            {
              name: "/Solutions",
              text: this.$t("solutions"),
              icon: "list_alt",
              can: this.$can("read", "settings"),
              notification: 0,
            },
            {
              name: "/Users",
              text: this.$t("users"),
              icon: "people",
              can: this.$can("read", "users"),
              notification: 0,
            },
            {
              name: "/Settings",
              group: true,
              text: this.$t("attributes"),
              icon: "toggle_on",
              can: this.$can("read", "settings"),
              notification: 0,
            },
          ],
          can: this.$can("read", "settings"),
        },
        {
          name: "/Help",
          group: true,
          notification: 0,
          text: this.$t("help"),
          icon: "help",
          can: true,
        },
      ];
    },
    snackbar() {
      return this.offlineUsers.length > 0;
    },
    isOffline() {
      return this.$store.state.isOffline;
    },
  },
  ready: function () {
    window.addEventListener("resize", this.onResize);
  },
  mounted() {},
  created() {
    this.$http
      .getLanguages()
      .then((res) => {
        this.$store.state.languages = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
    this.user = localStorage.getItem("user");
    if (localStorage.getItem("auth") != null) {
      this.$store.state.loggedIn = true;
      this.getNotifications();
      this.checkIfUserHasAcceptedTermsAndServices();
      this.getReleaseNotes();
    }
    this.checkConnection();
  },
};
</script>
<style>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
</style>

<style lang="scss">
html,
body {
  overscroll-behavior-y: contain;
}

$bg-primary-color: #0a3051;
$bg-highlight-color: #009bd9;
$bg-sub-highlight-color: #85c9f0;
$bg-purple-color: #4a2030;
$bg-green-color: #496c6f;
$bg-grey-color: #f2f5f8;

.theme--light.v-card.v-card--outlined {
  border: 0px solid rgba(10, 48, 81, 1) !important;
}
.theme--light.v-card.v-card--outlined {
  border: 0px solid rgba(10, 48, 81, 1) !important;
}

.md-app {
  min-height: 350px;
  border: 1px solid rgba(#000, 0.12);
}
.border1 {
  border: 1px solid rgba(#000, 0.12);
}
.active-row {
  border-left: 3px solid $bg-primary-color !important;
}
.active-row-right {
  border-right: 3px solid $bg-primary-color;
}
.active-row-bottom {
  border-bottom: 3px solid $bg-primary-color;
}
.sub-active-row {
  border-left: 3px solid $bg-primary-color;
}
.blueprint {
  background-image: url("./assets/pattern.jpg");
  background-repeat: repeat;
}
.clickable {
  cursor: pointer;
}
.moveable {
  cursor: grab;
}

.bg-primary {
  background-color: $bg-primary-color !important;
}
.bg-highlight {
  background-color: $bg-highlight-color !important;
}
.bg-sub-highlight {
  background-color: $bg-sub-highlight-color !important;
}
.bg-purple {
  background-color: $bg-purple-color !important;
}
.bg-green {
  background-color: $bg-green-color !important;
}
.bg-grey {
  background-color: $bg-grey-color !important;
}
.bg {
  background-image: url("./assets/bg.png");
  background-position: bottom left;
}

.flip-enter-active {
  transition: all 0.2s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.flip-leave-active {
  transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.flip-enter,
.flip-leave-to {
  transform: scaleY(0) translateZ(0);
  opacity: 0;
}

.offline-mode {
  background-color: #bdbdbd;
}
body {
  font-size: 0.8em;
}
.v-input__control {
  min-height: 30px !important;
}
.white-bg {
  background-color: white !important;
}
.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}
.list {
  max-height: 350px;
  overflow-y: auto;
}
// .list::-webkit-scrollbar {
//   display: none;
// }
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  background: #fff;
  -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-thumb {
  background: #85c9f0;
  -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-thumb:hover {
  background: #0a3051;
}
::-webkit-scrollbar-thumb:active {
  background: #0a3051;
  -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.v-card {
  // height: 100%
}
.sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 48px;
  z-index: 4;
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.sticky-toolbar-breadcrumb {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 72.5px;
  z-index: 4;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.sticky-breadcrumb {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 48px;
  z-index: 4;
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.sticky-offline {
  position: -webkit-sticky !important;
  position: sticky !important;
  top: 96px;
  z-index: 4;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.sticky-blueprint {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 129px;
  z-index: 3;
  overflow: hidden;
}
.sticky-blueprint-fullscreen {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 129px;
  overflow: hidden;
  z-index: 6;
}
.v-navigation-drawer__border {
  background-color: unset !important;
}

.v-card {
  // box-shadow: 0px 1px 1px 1px rgba(0, 0, 0, 0.0), 0px 1px 1px 0px rgba(0, 0, 0, 0.1), 0px 1px 1px 0px rgba(0, 0, 0, 00) !important;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.14) !important;
  // background-color: $bg-grey-color !important;
}

.v-expansion-panel:before {
  box-shadow: unset !important;
}
.floating-button {
  right: 0;
  left: 0;
  margin-right: auto;
  margin-left: auto;
  z-index: 50;
  overflow: unset;
  display: block;
  /* margin: 0px; */
  padding: 0px;
  border: 0px;
  transition: none 0s ease 0s;
  position: fixed;
  /* right: 10px; */
  bottom: 30px;
  width: 320.078px;
  height: 45px;
}

body.login {
  background: linear-gradient(-35deg, #0a3051, #85c9f0, #009bd9, #23d5ab);
  background-size: 400% 400%;
  animation: gradient 20s ease infinite;
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
body.home {
  background: #dae0e6 !important;
}
#inspire {
  background-color: transparent;
}

.pointer {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/App.vue